import React from 'react';
import { AppBar as MuiAppBar, IconButton, Toolbar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { styled } from '@mui/material/styles';
import logo from '../../images/marca-FAC-ENFERMERIA-FISIOTERAPIA-blanco.png';
import AccountMenu from './AccountMenu';

const drawerWidth = 240;

const StyledAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'isMobile',
})(({ theme, open, isMobile }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(!isMobile && open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function ShellAppBar({ open, toggleDrawer, isMobile }) {
  return (
    <StyledAppBar position="absolute" open={open} isMobile={isMobile}>
      <Toolbar sx={{ pr: { xs: 2, sm: 3 } }}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer}
          sx={{ marginRight: { xs: 2, sm: 4 }, ...(!isMobile && open && { display: 'none' }) }}
        >
          <MenuIcon />
        </IconButton>
        <Typography component="h1" variant="h6" color="inherit" noWrap sx={{ flexGrow: 1 }}>
          <img
            src={logo}
            alt="Logo Facultad de Enf. y Fisio."
            style={{ maxWidth: '188px', width: '100%', height: 'auto', marginTop: '10px' }}
          />
        </Typography>
        <AccountMenu />
      </Toolbar>
    </StyledAppBar>
  );
}
